export default "__VITE_ASSET__ff94917e__"